import React from "react";
import { _goToCompany } from "routers/helper";

import { View, StyleSheet, TouchableOpacity } from "react-native";
import ImgIcon from "components/imgIcon";
import Icon from "components/Icon";
import Text from "components/Text";

import { colors } from "assets/constants";
import { icons } from "assets/icons";
import { mq } from "utils";

export default function CompanyBox(props: { company: CompanyT }) {
  const { id, brand_name, name } = props.company;

  const _goToDetails = () => id && _goToCompany(id);

  return (
    <TouchableOpacity
      activeOpacity={0.85}
      onPress={_goToDetails}
      style={styles.box}
    >
      <View style={styles.container}>
        <View style={styles.row}>
          <ImgIcon
            size={mq(19)}
            icon={icons.company}
            color={colors.iconColor}
          />
          <View style={styles.container}>
            <Text
              numberOfLines={1}
              style={{ marginRight: mq(5) }}
              weight="bold"
            >
              {name}
            </Text>
          </View>
        </View>
        {brand_name && (
          <View style={{ ...styles.row, marginTop: mq(3) }}>
            <ImgIcon
              size={mq(20)}
              icon={icons.brand}
              color={colors.iconColor}
            />
            <View style={styles.container}>
              <Text
                numberOfLines={1}
                color={colors.textColorGray}
                size={"sm"}
                weight="bold"
                style={{ marginRight: mq(5) }}
              >
                {brand_name}
              </Text>
            </View>
          </View>
        )}
      </View>
      <Icon style={{ marginRight: mq(10) }} name="chevron-left" />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  box: {
    width: "100%",
    minHeight: 70,
    padding: mq(10),
    borderRadius: mq(10),
    alignItems: "center",
    flexDirection: "row-reverse",
    backgroundColor: colors.white,
  },
  container: { flex: 1 },
  row: { flexDirection: "row-reverse", alignItems: "center" },
});
